






































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import {isPermitEnterShop, ShopDataDto} from "@/api/shoppingMall";

@Component({
    name: 'ShopCard',
})
export default class ShopCard extends Vue {
    @Prop({
        default: () => {
        }
    }) data!: ShopDataDto;
    @Getter isFullMode!: boolean
    @Action setProviderId!: (val: string) => void;
    @Getter companyId!: string

    /**
     * 跳转到店铺首页
     * @param id 店铺id
     */
    toShopHome(id: string) {
        const obj = {
            shopId: id,
            customerId: this.companyId
        }
        isPermitEnterShop(obj).then((res) => {
            if (res.code === '000000') {
                this.setProviderId(id)
                this.$router.push('/shopHome')
            } else if (res.code === '000002') {
                this.$toast({
                    message: res.msg,
                    duration: 1000,
                    onClose: () => {
                        this.$emit('reloadList')
                    }
                })
            }
        })

    }
}
